import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";
import React from "react";
import { useDrag } from "react-dnd";
import styled from "styled-components";
import { GENERIC_COMPONENT } from "../Component";
import { ComponentItemProps, DefaultItem } from "../ComponentTree";
import { DragSpec, IEditableComponent } from "../EditableComponent";
import { NewItem } from "../NewComponents";
import { BarSelectProperty, BarTextProperty } from "../PropertiesBar";
import { YouTubeSpec, YOUTUBE_COMPONENT, YouTubeContainer } from "./YouTube";

const YouTubeInput = styled.div`
  margin-bottom: 15px;
`;

export const EditComponent = observer((props: { spec: YouTubeSpec }) => {
  if (!props.spec.youtubeUrl) {
    return (
      <div>
        <h3>YouTube Video</h3>
        <p>Bitte geben Sie eine YouTube-URL in den Eigenschaften an.</p>
      </div>
    );
  }

  return (
    <YouTubeContainer size={props.spec.size || "medium"}>
      <div className="video-container">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${getYouTubeVideoId(
            props.spec.youtubeUrl
          )}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>
    </YouTubeContainer>
  );
});

const getYouTubeVideoId = (url: string): string => {
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);

  if (match && match[2].length === 11) {
    return match[2];
  }

  return "";
};

const Properties = observer((props: { spec: YouTubeSpec }) => {
  return (
    <div>
      <YouTubeInput>
        <BarTextProperty
          name="YouTube URL"
          value={props.spec.youtubeUrl || ""}
          onChange={(newValue) => (props.spec.youtubeUrl = newValue)}
        />
      </YouTubeInput>
      <BarSelectProperty
        name="Größe"
        value={props.spec.size || "medium"}
        options={[
          { value: "small", label: "Klein" },
          { value: "medium", label: "Mittel" },
          { value: "large", label: "Groß" },
        ]}
        onChange={(newValue) =>
          (props.spec.size = newValue as "small" | "medium" | "large")
        }
      />
    </div>
  );
});

const Item = observer((props: ComponentItemProps<YouTubeSpec>) => {
  return <DefaultItem {...props} icon={faYoutube} name="YouTube" />;
});

const New = () => {
  const [, drag] = useDrag<DragSpec, unknown, unknown>(() => ({
    type: GENERIC_COMPONENT,
    item: {
      spec: {
        type: YOUTUBE_COMPONENT,
        youtubeUrl: "",
        size: "medium",
      },
    },
  }));
  return (
    <NewItem
      isActive={false}
      ref={(elem) => {
        drag(elem);
      }}
    >
      <FontAwesomeIcon icon={faYoutube} />
      <span> YouTube </span>
    </NewItem>
  );
};

export const YouTubeComponent: IEditableComponent<YouTubeSpec> = {
  component: EditComponent,
  properties: Properties,
  item: Item,
  new: New,
};
